var navigation = []
var secondaryNavigation = []
var standaloneNavigation = []
var apoOneNavigation = []

const requireContext = require.context('.', false, /.*\.(js)$/)
requireContext.keys().forEach(file => {
  const navigationFile = requireContext(file)

  if ('default' in navigationFile) {
    if (file === './apo_one.js') {
      apoOneNavigation = apoOneNavigation.concat(navigationFile.default)
    } else if (file === './secondary.js') {
      secondaryNavigation = secondaryNavigation.concat(navigationFile.default)
    } else if (file === './standalone.js') {
      standaloneNavigation = standaloneNavigation.concat(navigationFile.default)
    } else {
      navigation = navigation.concat(navigationFile.default)
    }
  }

})

export default {navigation, secondaryNavigation, standaloneNavigation, apoOneNavigation}
